import { HttpInterceptorFn } from '@angular/common/http';

export const cookieInterceptor: HttpInterceptorFn = (request, next) => {
    const isCurrencyRequest = request.url.includes('api.freecurrencyapi.com');
    const authRequest = request.clone({
        withCredentials: isCurrencyRequest ? false : true,
    });
    return next(authRequest);
};
